import React, { Component } from 'react';
import { Router, Route, Switch, withRouter } from 'react-router';
import withRole from 'components/Security/withRole';
import DataGridStateContextProvider from 'components/DataGrid/DataGridStateContext';
import {
  ROLE_CREATE_ZONE_CATEGORY,
  ROLE_EDIT_ZONE_CATEGORY,
  ROLE_SHOW_ZONE_CATEGORY,
} from 'helpers/roles';

import List from './List';
import Form from './Form';

class ZoneCategories extends Component {
  render() {
    const { props } = this;

    const ListSecured = withRole(ROLE_SHOW_ZONE_CATEGORY, List);
    const CreateForm = withRole(ROLE_CREATE_ZONE_CATEGORY, Form);
    const EditForm = withRole(ROLE_EDIT_ZONE_CATEGORY, Form);

    return (
      <DataGridStateContextProvider>
        <Router history={this.props.history}>
          <Switch>
            <Route
              exact={true}
              path={`${this.props.match.url}/`}
              render={parentProps => <ListSecured {...props} {...parentProps} />}
            />
            <Route
              path={`${this.props.match.url}/add`}
              render={() => <CreateForm {...props} />}
            />
            <Route
              path={`${this.props.match.url}/edit/:id`}
              render={parentProps => <EditForm {...props} {...parentProps} />}
            />
          </Switch>
        </Router>
      </DataGridStateContextProvider>
    );
  }
}

export default withRouter(ZoneCategories);
